export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  children?: INavigationRoute[]
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'menu.dashboard',
      meta: {
        icon: 'vuestic-iconset-dashboard',
      },
    },
    {
      name: 'services',
      displayName: 'menu.services',
      meta: {
        icon: 'miscellaneous_services',
      },
    },
    {
      name: 'orders',
      displayName: 'menu.orders',
      meta: {
        icon: 'receipt_long',
      },
    },
    {
      name: 'invoices',
      displayName: 'menu.invoices',
      meta: {
        icon: 'request_quote',
      },
    },
    {
      name: 'payments',
      displayName: 'menu.payments',
      meta: {
        icon: 'payments',
      },
    },
    {
      name: 'tickets',
      displayName: 'menu.tickets',
      meta: {
        icon: 'support_agent',
      },
    },
    {
      name: 'preferences',
      displayName: 'menu.preferences',
      meta: {
        icon: 'manage_accounts',
      },
    },

  ] as INavigationRoute[],
}
